import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

/**
 * ReadMore — inline collapsible text block. Shows a short preview,
 * then reveals the rest on click. Reduces visual text density on
 * long-copy pages.
 */
export default function ReadMore({
  preview,
  more,
  buttonMoreLabel = "Read more",
  buttonLessLabel = "Read less",
  className = "",
  testId = "read-more",
}) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`font-manrope text-white/70 ${className}`} data-testid={testId}>
      <p className="leading-relaxed">
        {preview}
        {!open && (
          <>
            {" "}
            <button
              type="button"
              onClick={() => setOpen(true)}
              className="text-brand font-semibold hover:underline inline-flex items-center gap-1"
              data-testid={`${testId}-open`}
            >
              {buttonMoreLabel} <ChevronDown className="w-3.5 h-3.5" />
            </button>
          </>
        )}
      </p>
      {open && (
        <div className="mt-3 space-y-3 leading-relaxed animate-fade-in">
          {Array.isArray(more)
            ? more.map((p, i) => <p key={i}>{p}</p>)
            : <p>{more}</p>}
          <button
            type="button"
            onClick={() => setOpen(false)}
            className="text-brand font-semibold hover:underline inline-flex items-center gap-1"
            data-testid={`${testId}-close`}
          >
            {buttonLessLabel} <ChevronUp className="w-3.5 h-3.5" />
          </button>
        </div>
      )}
    </div>
  );
}
